import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import PageHeader from '../components/PageHeader';

const filters = ['all', 'journal', 'proceedings'];

const Publications = () => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState('all');

  const publications = t('publications.items', { returnObjects: true });
  const list = Array.isArray(publications) ? publications : [];
  const filtered = filter === 'all' ? list : list.filter((pub) => pub.type === filter);

  return (
    <div>
      <PageHeader eyebrow="Kalle Glauch" title={t('publications.title')} lead={t('publications.lead')} />

      <div className="mx-auto max-w-5xl px-6 py-14 md:px-10 md:py-16">
        {/* Filter */}
        <div className="mb-10 inline-flex flex-wrap gap-1 rounded-md border border-line bg-beige-50 p-1">
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`rounded-sm px-3.5 py-1.5 text-xs font-medium tracking-wide transition-colors duration-200 ${
                filter === f ? 'bg-navy-900 text-[color:var(--on-navy)]' : 'text-ink-600 hover:text-navy-700'
              }`}
            >
              {t(`publications.${f}`)}
            </button>
          ))}
        </div>

        {/* List */}
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }}>
          {filtered.map((pub, index) => (
            <motion.article
              key={index}
              className="border-b border-line py-6 first:pt-0 last:border-0"
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.04 }}
            >
              <div className="mb-2 flex flex-wrap items-center gap-x-2.5 gap-y-1">
                <span className="eyebrow">{t(`publications.typeLabel.${pub.type}`, pub.type)}</span>
                <span className="text-ink-400">·</span>
                <span className="text-xs tracking-wide text-ink-400">{pub.year}</span>
              </div>
              <h2 className="text-base font-semibold leading-snug text-ink-900">{pub.title}</h2>
              <p className="mt-1.5 text-sm text-ink-600">
                {pub.authors} · <span className="font-display italic text-ink-900">{pub.venue}</span>
              </p>
              {pub.doi && (
                <a
                  href={pub.doi.startsWith('http') ? pub.doi : `https://doi.org/${pub.doi}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-2.5 inline-flex items-center gap-1.5 text-sm text-navy-600 transition-colors hover:text-navy-800"
                >
                  DOI
                  <ExternalLink size={14} />
                </a>
              )}
            </motion.article>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Publications;
